
import { motion } from "framer-motion";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Helmet } from "react-helmet-async";
import PageHeader from "@/components/how-to-play/PageHeader";
import HeroSection from "@/components/how-to-play/HeroSection";
import AboutSection from "@/components/how-to-play/AboutSection";
import FeaturesGrid from "@/components/how-to-play/FeaturesGrid";
import AudienceSection from "@/components/how-to-play/AudienceSection";
import MarketStatsSection from "@/components/how-to-play/MarketStatsSection";
import CallToAction from "@/components/how-to-play/CallToAction";

const HowToPlay = () => {
  return (
    <div className="min-h-screen bg-racing-dark text-white">
      <Helmet>
        <title>How To Play | Front Runner: Racehorse Manager Guide</title>
        <meta name="description" content="Learn how to play Front Runner: Racehorse Manager. Master stable management, horse training, and race strategy to become a champion in the world of virtual horse racing." />
        <meta name="keywords" content="front runner game guide, horse racing game tutorial, racehorse manager instructions, how to play horse racing game" />
        
        {/* Primary Meta Tags */}
        <meta itemProp="name" content="How To Play | Front Runner: Racehorse Manager Guide" />
        <meta itemProp="description" content="Master stable management, horse training, and race strategy to become a champion in Front Runner: Racehorse Manager." />
        <meta itemProp="image" content="https://c0b7ec99-c595-43b9-be02-b9d207bd20c5.lovableproject.com/lovable-uploads/FRRM-trailerImage.webp" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://frontrunnergame.com/how-to-play" />
        <meta property="og:title" content="How To Play | Front Runner: Racehorse Manager Guide" />
        <meta property="og:description" content="Master stable management, horse training, and race strategy to become a champion in Front Runner: Racehorse Manager." />
        <meta property="og:image" content="https://c0b7ec99-c595-43b9-be02-b9d207bd20c5.lovableproject.com/lovable-uploads/FRRM-trailerImage.webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://frontrunnergame.com/how-to-play" />
        <meta name="twitter:title" content="How To Play | Front Runner: Racehorse Manager Guide" />
        <meta name="twitter:description" content="Master stable management, horse training, and race strategy to become a champion in Front Runner: Racehorse Manager." />
        <meta name="twitter:image" content="https://c0b7ec99-c595-43b9-be02-b9d207bd20c5.lovableproject.com/lovable-uploads/FRRM-trailerImage.webp" />
        
        {/* Canonical link */}
        <link rel="canonical" href="https://frontrunnergame.com/how-to-play" />
      </Helmet>
      <Navigation />
      <main className="container mx-auto px-4 py-24 md:py-32">
        <div className="relative min-h-screen bg-racing-dark text-white pt-24 overflow-hidden">
          {/* Background gradient effects */}
          <div className="absolute inset-0" />
          <div className="absolute inset-0 bg-[url('/lovable-uploads/FRRM-website-BG.svg')] bg-cover opacity-5" />
          
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            className="container mx-auto px-4 py-12 space-y-16 relative z-10"
          >
            <HeroSection />

            <section className="prose prose-invert mx-auto max-w-4xl">
              <AboutSection />
              <FeaturesGrid />
              <AudienceSection />
              <MarketStatsSection />
            </section>

            <CallToAction />
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default HowToPlay;
